import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";
// Connects to data-controller="navigate-variant"
export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this.onChange);
  }

  disconnect() {
    this.element.removeEventListener("change", this.onChange);
  }

  onChange(event) {
    Turbo.visit(event.currentTarget.value);
  }
}
